<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''" style="min-height: 100%">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ _.startCase(currentProfile) }}
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="accessRights.includes('T')" class="dropdown-item"
                @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-print"></i>
                <span>Print</span>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
            </template>
          </base-dropdown>

          <div v-if="serverType == 'ho'">
            <div v-if="checkedItems.length == 0 && accessRights.includes('A')">
              <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">+ Add
                {{ _.startCase(_.singularize(currentProfile)) }}</base-button>
            </div>

            <div v-else-if="checkedItems.length > 0 && accessRights.includes('W')">
              <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'A')">Activate</base-button>
              <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default" size="sm"
                @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
              <div class="ml-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br />

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <draggable :key="draggableKey" :list="availableFields" class="list-group" @start="dragging = true"
          @end="dragging = false">
          <div class="list-group-item draggable"
            :style="index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''"
            v-for="(element, index) in availableFields" :key="element">
            <div class="row">
              <!-- This _.startCase() will convert any casing into Start Case -->
              <div class="col-md-6">
                {{ _.startCase(element) }}
              </div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <div>
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            Export All
          </base-radio>
          <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
            Export Current Page
          </base-radio>
          <base-radio name="2" class="mb-3" v-model="filterStatus" value="2">
            Export Selected
          </base-radio>
          <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
            Export Filtered
          </base-radio>
        </div>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          ">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">
            Export
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'import_list'">
        <import-profile @closeDrawer="closeDrawer"></import-profile>
      </div>
    </a-drawer>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <div>
        <brand-form v-if="currentProfile == 'brands'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></brand-form>
        <color-form v-if="currentProfile == 'colors'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></color-form>
        <design-form v-if="currentProfile == 'designs'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></design-form>
        <product-line-form v-if="currentProfile == 'product_lines'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></product-line-form>
        <property-form v-if="currentProfile == 'properties'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></property-form>
        <size-group-form v-if="currentProfile == 'size_groups'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></size-group-form>
        <style-form v-if="currentProfile == 'styles'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></style-form>
        <unit-form v-if="currentProfile == 'units'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></unit-form>
        <product-group-form v-if="currentProfile == 'product_groups'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></product-group-form>
        <epay-logo-form v-if="currentProfile == 'epay_logos'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></epay-logo-form>
        <epay-guide-form v-if="currentProfile == 'epay_guides'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></epay-guide-form>
        <epay-type-form v-if="currentProfile == 'epay_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></epay-type-form>
        <foreign-supplier-form v-if="currentProfile == 'foreign_suppliers'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage"
          :key="componentKey" :viewMode="viewMode"></foreign-supplier-form>
      </div>
    </a-drawer>

    <div class="table-responsive" v-if="currentProfile == 'size_groups'">
      <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
        @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log" @vuetable:load-error="onLoadError"
        @vuetable:pagination-data="onPaginationData" :row-class="onRowClass">
        <template slot="actions" slot-scope="props">
          <center>
            <div v-if="serverType == 'ho'" class="table-button-container">
              <button id="view" v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                @click.prevent="showDrawer(props.rowData.id)">
                View
              </button>
              <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm"
                @click.prevent="showDrawer(props.rowData.id)">
                Edit
              </button>
              <a-popconfirm v-if="accessRights.includes('D')" title="You are about to delete this record?"
                @confirm="deleteRow(props.rowData.id)" okText="Delete" cancelText="Cancel">
                <a class="btn btn-danger btn-sm text-white">Delete</a>
              </a-popconfirm>
            </div>
            <div v-else class="table-button-container">
              <button class="btn btn-success btn-sm" v-if="accessRights.includes('V')"
                @click.prevent="showDrawer(props.rowData.id)">
                View</button>&nbsp;&nbsp;
            </div>
          </center>
        </template>
      </vuetable>
    </div>
<!-- jc -->

    <!--  Brand Table -->
    <div class="table-responsive tbl-brand" v-else-if="currentProfile == 'brands'">
      <a-spin :spinning="spinner" tip="Checking...">
      <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
        @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log" @vuetable:load-error="onLoadError"
        @vuetable:pagination-data="onPaginationData" @vuetable:row-clicked="onRowClick" :row-class="onRowClass">
        <template slot="actions" slot-scope="props">
          <center>
            <div v-if="serverType == 'ho'" class="table-button-container">
              <button id="view" v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                @click.prevent="showDrawer(props.rowData.id)">
                View
              </button>
              <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm"
                @click.prevent="showDrawer(props.rowData.id)">
                Edit
              </button>
              <!-- <a-popconfirm v-if="accessRights.includes('D')" title="You are about to delete this record?"
                @confirm="deleteRow(props.rowData.id)" okText="Delete" cancelText="Cancel">
                <a class="btn btn-danger btn-sm text-white">Delete</a>
              </a-popconfirm> -->
               <button v-if="accessRights.includes('D')" @click.prevent="checkBindedItems(props.rowData.id)"  class="btn btn-danger btn-sm text-white">
                  Delete
               </button>
            </div>
            <div v-else class="table-button-container">
              <button class="btn btn-success btn-sm" v-if="accessRights.includes('V')"
                @click.prevent="showDrawer(props.rowData.id)">
                View</button>&nbsp;&nbsp;
            </div>
          </center>
        </template>
      </vuetable>
      </a-spin>
      <a-modal 
                :visible="showModal" 
                :title="bindedItems !== 0? 'Cannot delete attribute' : 'You are about to delete this record?'" 
                :okButtonProps="bindedItems !== 0 && { style: { display: 'none'} }"
                cancelText="Close"
                okText="Proceed"
                @ok="deleteAttribute(currentRowDataId)" 
                @cancel="closeModal"
                :closable="false"
                >
                <p v-if="bindedItems!== 0">
                  There are {{ bindedItems }} item/s currently using this attribute. <br>
                </p>
                <p v-else>
                  Would you like to continue ?
                </p>
              </a-modal>
    </div>
    <!--  Brand Table -->

    <div v-else class="table-responsive">
      <a-spin :spinning="spinner" tip="Checking...">
      <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
        no-data-template="Empty" @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log"
        @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">
        <template slot="actions" slot-scope="props">
          <center>
            <div v-if="serverType == 'ho'" class="table-button-container">
              <button id="view" v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                @click.prevent="showDrawer(props.rowData.id)">
                View
              </button>
              <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm"
                @click.prevent="showDrawer(props.rowData.id)">
                Edit
              </button>
              <a-popconfirm 
                v-if="accessRights.includes('D') 
                && currentProfile !== 'colors' 
                && currentProfile !== 'properties'
                && currentProfile !== 'product_groups'
                && currentProfile !== 'product_lines'" 
                title="You are about to delete this record?"
                @confirm="deleteRow(props.rowData.id)" okText="Delete" cancelText="Cancel">
                <a class="btn btn-danger btn-sm text-white">Delete</a>
              </a-popconfirm>

              <button v-else="accessRights.includes('D') 
                && currentProfile === 'colors' 
                && currentProfile === 'properties'
                && currentProfile === 'product_groups'
                && currentProfile === 'product_lines'"
                @click.prevent="checkBindedItems(props.rowData.id)"  
                class="btn btn-danger btn-sm text-white">
                  Delete
               </button>
            </div>
            <div v-else class="table-button-container">
              <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                @click.prevent="showDrawer(props.rowData.id)">
                View</button>&nbsp;&nbsp;
            </div>
          </center>
        </template>
      </vuetable>
      </a-spin>
      <a-modal 
                :visible="showModal" 
                :title="bindedItems !== 0? 'Cannot delete attribute' : 'You are about to delete this record?'" 
                :okButtonProps="bindedItems !== 0 && { style: { display: 'none'} }"
                cancelText="Close"
                okText="Proceed"
                @ok="deleteAttribute(currentRowDataId)" 
                @cancel="closeModal"
                :closable="false"
                >
                <p v-if="bindedItems!== 0">
                  There are {{ bindedItems }} item/s currently using this attribute. <br>
                </p>
                <p v-else>
                  Would you like to continue ?
                </p>
              </a-modal> 
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import BrandForm from "../Product Profiles V2/BrandForm.vue";
import ColorForm from "../Product Profiles V2/ColorForm.vue";
import ProductGroupForm from "../Product Profiles V2/ProductGroupForm";
import DesignForm from "../Product Profiles V2/DesignForm.vue";
import ProductLineForm from "../Product Profiles V2/ProductLineForm.vue";
import PropertyForm from "../Product Profiles V2/PropertyForm.vue";
import SizeGroupForm from "../Product Profiles V2/SizeGroupForm.vue";
import StyleForm from "../Product Profiles V2/StyleForm.vue";
import ForeignSupplierForm from "../Product Profiles V2/ForeignSupplierForm.vue";
import UnitForm from "../Product Profiles V2/UnitForm.vue";
import EpayLogoForm from "../Product Profiles V2/EpayLogoForm.vue";
import EpayGuideForm from "../Product Profiles V2/EpayGuideForm.vue";
import EpayTypeForm from "../Product Profiles V2/EpayTypeForm.vue";
import ImportProfile from "../ImportProfile";

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from "../../controllers/secureStorage";
import HTTPRequest from "../../controllers/httpRequest.js";
import draggable from "vuedraggable";
import { formatStatus } from "../../utilities.js"

var component_x;

export default {
  name: "profiles-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  components: {
    Vuetable,
    VuetablePagination,
    BrandForm,
    ColorForm,
    DesignForm,
    ProductLineForm,
    PropertyForm,
    SizeGroupForm,
    StyleForm,
    ForeignSupplierForm,
    UnitForm,
    ImportProfile,
    EpayLogoForm,
    EpayGuideForm,
    EpayTypeForm,
    ProductGroupForm,
    draggable
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "profileId",
      "parameters",
      "parentId",
      "serverType",
    ]),
  },
  data() {
    return {
      // bryan
      showModal:false,
      bindedItems: 0,
      spinner:false,
      currentRowDataId:null,
      // end
      viewMode: false,
      accessRights: [],
      filterStatus: "",
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      apiURL: "",
      fields: [],
      sortOrder: [
        {
          field: "name",
          direction: "asc",
        },
      ],
      httpOptions: {
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
      },
      css: {
        table: {
          tableClass:
            "table table-sm table-striped table-bordered table-hovered",
          loadingClass: "loading",
        },
        pagination: {
          infoClass: "pull-right",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary btn-sm",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      draggableKey: 0
    };
  },
  watch: {
    currentApiURL: function () {
      this.$refs.vuetable.resetData();
      this.apiURL = this.currentApiURL;
    },
    parameters: function () {
      this.apiURL = this.currentApiURL;
      this.apiURL = this.apiURL + this.parameters;
      this.$refs.vuetable.selectedTo = [];
      this.checkedItems = [];
    },
    currentProfile: function () {
      this.initializeTable()
    },
    checkedFields: function () {
      if (!this.checkedFields.length) {
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.',
          placement: 'bottomRight'
        })
        this.checkedFields = ["id","code", "name", "status"]
        this.fields = ["__checkbox", "id", "code", "name", { name: "status", callback: (value) => formatStatus(value)}, "__slot:actions"]
        this.reinitializeFields();
      }
    }
  },
  methods: {
    ...mapActions(["updateProfileId", "updateParentId"]),
    closeDrawer() {
      this.onClose();
    },
    refreshPage() {
      this.onClose();
      this.$refs.vuetable.refresh();
      this.successMessage = "Successful Operation";
      this.errorMessage = null;
    },
   
    onRowClass(dataItem) {
      return dataItem.id == this.parentId ? "table-success" : "";
    },
    showDrawer(id) {
      if (event.target.id == "view") {
        this.viewMode = true;
      } else {
        this.viewMode = false;
      }

      this.componentKey++;
      this.updateProfileId(id);
      this.visible = true;
    },
    async showActionDrawer(action) {
      if (action == "customize_list") {
        var response = await HTTPRequest.getRequest(
          this.endPoint + this.currentProfile + "/get_viewable_fields",
          null
        );
        
        let unsortedFields = response["fields"];
        let sortedFields = this.checkedFields.slice();

        unsortedFields.forEach(fieldName => {
          if (!this.checkedFields.includes(fieldName))
            sortedFields.push(fieldName)
        });

        this.availableFields = sortedFields;

      }
      this.profileAction = action;
      this.drawerVisible = true;
    },
    onClose() {
      this.drawerVisible = false;
      this.visible = false;
      this.componentKey++;
    },
    onRowClick(dataItem){
      this.updateParentId(dataItem.id);
    },
    // bryan
    log() {
      this.checkedItems = this.$refs.vuetable.selectedTo;
      const dataItem = this.$refs.vuetable.tableData.filter( ({ id }) => id === this.checkedItems[(this.checkedItems.length - 1)] )
      const dataId = dataItem[0] == undefined? undefined : dataItem[0].id
      const dataName = dataItem[0] == undefined? undefined : dataItem[0].name
      this.updateParentId(dataId);
      this.$emit("selectName", dataName)
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) {
          this.checkedFields.splice(indexValue, 1);
        }
      } else {
        this.checkedFields.push(fieldName);
      }
      // insert object status in fields
      if (this.fields.includes(fieldName)) {
        var indexValue2 = this.fields.indexOf(fieldName);
        if (indexValue2 > -1) {
          this.fields.splice(indexValue2, 1);
        }
      }else{
        if(fieldName == 'status'){
          let status_exist = false;
          this.fields.forEach((field, index) => {
            if(typeof field === 'object'){
              status_exist = index;
            }
          })
          if (status_exist){
            this.fields.splice(status_exist, 1)
          }else{
            this.fields.pop()
            this.fields.push({ name: "status", callback: (value) => formatStatus(value)})
            this.fields.push("__slot:actions")
          }
        }else{
          this.fields.pop()
          this.fields.push(fieldName)
          this.fields.push("__slot:actions")
        }
      }
      const localStoreName = this.currentProfile + "ProductProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields))
      this.$refs.vuetable.normalizeFields();
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        // console.log("Empty")
        this.checkedFields = [];
        // this.fields = ["__checkbox", "id", "name", "__slot:actions"];
      } else {
        this.checkedFields = this.availableFields.slice();
        this.fields = ["__checkbox"];
        this.fields = this.fields.concat(this.checkedFields);
        this.fields = this.fields.map((value) =>{
          if(value == 'status'){
            return  { name: "status", callback: (value) => formatStatus(value) }
          }else{
            return value
          }
        })
        this.fields.push("__slot:actions");
      }
      const localStoreName = this.currentProfile + "ProductProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields))
      this.reinitializeFields();
    },
    reinitializeFields() {
      this.$nextTick(() => {
        this.$refs.vuetable.normalizeFields();
      });
    },
    async massupdate(field_name, value) {
      var field_update = {};
      field_update[field_name] = value;
      var payload = {
        ids: this.checkedItems,
        field_update: field_update,
      };
      var response = await HTTPRequest.postRequest(
        this.endPoint + this.currentProfile + "/mass_update",
        null,
        payload
      );
      if (response["message"] == "Ok") {
        this.successMessage = "Update successful!";
        this.$refs.vuetable.refresh();
        this.checkedItems = [];
        this.$refs.vuetable.selectedTo = [];
      } else {
        this.successMessage = "Update failed!";
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(
          component_x.endPoint
        );
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.");
          this.$router.push("/");
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    // bryan START
    async checkBindedItems(id){
      this.spinner = true
     axios({
        method: "get",
        url: this.endPoint + this.currentProfile + "/check_binded_items?id=" + id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
      }).then(function (resp) {
          component_x.spinner = false
          component_x.showModal = true
          // console.log(resp.data.length)
          component_x.bindedItems = resp.data.length
          component_x.currentRowDataId = id
        })
        .catch(function () {
          alert("Invalid Credentials");
          component_x.spinner = false
        });
    },
    deleteAttribute(id){
      this.deleteRow(id)
      this.closeModal()
    },
    closeModal(){
      this.showModal = !this.showModal 
    },
    // bryan END
    deleteRow(id) {
      // console.log(this.endPoint + this.currentProfile + "/" + id)
      axios({
        method: "delete",
        url: this.endPoint + this.currentProfile + "/" + id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
      })
        .then(function () {
          component_x.successMessage = "Successfully deleted record";
          component_x.$refs.vuetable.refresh();
        })
        .catch(function () {
          alert("Invalid Credentials");
        });
    },
    download() {
      var payload = {};
      var additional_parameters = "";
      var baseUrl = this.currentApiURL + "/download?file_type=csv";
      if (this.filterStatus == "0") {
        // All
        payload["type"] = "all";
      } else if (this.filterStatus == "1") {
        // Current Page
        payload["type"] = "current_page";
        additional_parameters = this.parameters;
        additional_parameters =
          additional_parameters +
          "&page=" +
          this.$refs.vuetable.currentPage +
          "&per_page=" +
          this.$refs.vuetable.perPage;
      } else if (this.filterStatus == "2") {
        // Selected
        payload["type"] = "selected";
        payload["ids"] = this.checkedItems;
      } else {
        // Filtered
        payload["type"] = "filtered";
        additional_parameters = this.parameters;
      }

      var exportFields = this.fields;
      var cbIndex = this.fields.indexOf("__checkbox");
      if (cbIndex > -1) exportFields.splice(cbIndex, 1);
      var actionIndex = this.fields.indexOf("__slot:actions");
      if (actionIndex > -1) exportFields.splice(actionIndex, 1);

      payload["fields"] = exportFields;
      additional_parameters = additional_parameters.replace("?", "&");

      axios({
        url: baseUrl + additional_parameters,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") 
        },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.csv");
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null;
        this.successMessage = "Download successful";
      });
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose();
        this.errorMessage = message["error"];
        this.successMessage = null;
      }
    },
    removeMessage(type) {
      if (type == "error") this.errorMessage = null;
      else this.successMessage = null;
    },
    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["id", "code", "name", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }

      let localStoreName = this.currentProfile + "ProductProfileCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));

      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else return column
      })
      this.fields.push("__slot:actions");
      this.fields.unshift("__checkbox")

      this.reinitializeFields();
      this.onClose();
    }
  },
  beforeMount: async function () {
    const posProfileCustomList = localStorage.getItem(this.currentProfile + "ProductProfileCheckedFields")
    if (posProfileCustomList != undefined && posProfileCustomList != null && posProfileCustomList != "[]") {
      this.checkedFields = JSON.parse(posProfileCustomList)
      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        } else return column
      })
      this.fields.push("__slot:actions")
      this.fields.unshift("__checkbox")
      this.initLoad++
    } else {
      this.checkedFields = ["id", "code", "name", "status"];
      this.fields = [
        "__checkbox",
        "id",
        "code",
        "name",
        {
          name: "status",
          callback: (value) => formatStatus(value)
        },
        "__slot:actions"
      ];
      localStorage.removeItem(this.currentProfile + "ProductProfileCheckedFields")
    }
  },
  mounted: function () {
    component_x = this;
    this.accessRights = this.$attrs.accessRights;
    this.apiURL = this.currentApiURL;
    console.log('profile',component_x.currentProfile)
    console.log('info',component_x.serverType,component_x.checkedItems.length)
    console.log('rights', component_x.accessRights.includes('A'))
    console.log('pid',component_x.profileId)

  },
};
</script>

<style lang="scss">
.tbl-brand {
  .table {
    tbody {
      tr {
        cursor: pointer;
      }
    }
  }
}

.draggable {
  cursor: grab
}
</style>
